// JS for workbook-variant-buttons-v2.liquid
// Handles plan comparison radio buttons and updates hidden fields

document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.getElementById('plan-comparison-wrapper');
  if (!wrapper) return;

  const kitTypeField = document.getElementById('kit-type-field');

  // Find the product form's variant input
  const productForm = document.querySelector('product-form form');
  const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;

  // Update kit type field and variant input when variant changes
  const radios = wrapper.querySelectorAll('input[type="radio"]');
  radios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        const planType = this.getAttribute('data-plan-type');
        const variantId = this.getAttribute('data-variant-id');

        if (kitTypeField) {
          kitTypeField.value = planType;
        }

        if (variantInput && variantId) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  // Initialize kit type field and variant input on page load
  const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
  if (checkedRadio) {
    const planType = checkedRadio.getAttribute('data-plan-type');
    const variantId = checkedRadio.getAttribute('data-variant-id');

    if (kitTypeField) {
      kitTypeField.value = planType;
    }

    if (variantInput && variantId) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});
